export const zh = {
    //业务模块国际化
    userList: {
        id: '编号',
        userName: '用户名',
        syncUser: '同步用户',
        userCd: '用户账号',
        supplierCode: '供应商CODE',
        email: '邮箱',
        phone: '手机号',
        sex: '性别',
        userWorkLanguage: '工作语言',
        selSex: '请选择性别',
        selLanguage: '请选择工作语言',
        sys: '所属系统',
        userType: '用户类型',
        hrStatus: '是否有效',
        userInfo: '用户基本信息',
        inputName: '请输入用户姓名',
        inputUserCd: '请输入用户账号',
        inputPhone: '请输入手机号',
        inputPhone11: '请输入11位有效手机号号码',
        inputEmail: '输入正确的邮箱地址',
        createDate: '创建日期',
        errorMsg: '错误信息',
        addRole: '添加角色',
        roleSelection: '角色选择',
        roleSource: '来源',
        roleTarget: '目标',
        syscMessage: '后台同步数据中，请稍候查看',
        UploadSignature: '上传签名',
        Language: '语言'
    },
    roleList: {
        roleNo: '角色编号',
        syncUser: 'Sync User',
        roleCN: '中文名称',
        roleEN: '英文名称',
        roleInfo: '角色基本信息',
        roleSet: '权限设置',
        roleFunction: '角色权限',
        inputRoleNo: '请输入角色编号',
        inputRoleCN: '请输入角色名称',
        inputRoleEN: '请轮入角色名称',
        selectDelRole: '请选择需要删除的角色'
    },
    function: {
        functionCN: '中文名称',
        functionEN: '英文名称',
        functionCode: '权限Code',
        functionMenuLevel: '权限级别',
        functionId: '权限Id',
        parentFunctionId: '父节点ID',
        functionNo: '权限编号',
        functionInfo: '权限基本信息',
        functionIsMenu: '菜单',
        functionIsWhiteList: '白名单',
        inputFunctionCN: '请输入权限中文名称',
        inputFunctionNo: '请输入权限编号',
        inputMenuLevel: '请输入级别',
        inputParent: '请输入父节点',
        selectWhiteList: '请选择是否为白名单',
        inputFunctionCode: '请选输入权限CODE',
        selectDelFunction: '请选择需要删除的权限'
    }
}

export const en = {
    //业务模块国际化
    userList: {
        id: 'ID',
        userName: 'userName',
        userCd: 'userCd',
        email: 'E-Mail',
        phone: 'Phone',
        sex: 'Sex',
        userType: 'User Type',
        userWorkLanguage: 'language',
        selSex: 'Please select sex',
        selLanguage: 'Please select language',
        sys: 'System',
        hrStatus: 'Status',
        userInfo: 'Basic information of users',
        inputName: 'Please enter user name',
        inputUserCd: 'Please enter userCd',
        inputPhone: 'Please enter phone',
        inputPhone11: 'Please enter 11 valid mobile number',
        inputEmail: 'Please enter the correct email address',
        createDate: 'Create date',
        errorMsg: 'Error message',
        addRole: 'Add role',
        roleSelection: 'Role selection',
        roleSource: 'Source',
        roleTarget: 'Target',
        syscMessage: 'Please wait to see the backend synchronization data',
        UploadSignature: 'Upload signature',
        Language: 'Language'
    },
    roleList: {
        roleNo: 'Role NO.',
        roleCN: 'Chinese name',
        roleEN: 'English name',
        roleInfo: 'Role basic info',
        roleSet: 'Permission ',
        roleFunction: 'Role permissions',
        inputRoleNo: 'Please enter role no',
        inputRoleCN: 'Please enter role name',
        inputRoleEN: 'Please enter rle name',
        selectDelRole: 'Please select the role to delete',
    },
    function: {
        functionCN: 'Chinese name',
        functionEN: 'English name',
        functionCode: 'Permissions code',
        functionMenuLevel: 'Level',
        functionId: 'ID',
        parentFunctionId: 'Parent ID',
        functionNo: 'Permissions No',
        functionInfo: 'Permission basic information',
        functionIsMenu: 'The menu',
        functionIsWhiteList: 'White list',
        inputFunctionCN: 'Please enter name',
        inputFunctionNo: 'Please enter permissions no',
        inputMenuLevel: 'Please enter level:',
        inputParent: 'Please enter parent ID',
        selectWhiteList: 'Please select white list or not',
        inputFunctionCode: 'Please enter permissions code',
        selectDelFunction: 'Please select the function to delete'
    }
}